<template>
     <div class="main-content" id="panel">
         <!-- <Header /> -->
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                </div>
                <div class="text-right col-lg-6 col-5">
                <span class="time">Local: <i class="fas fa-clock"></i> <time v-text="timeDate"></time> </span>
                <span class="time">EST: <i class="fas fa-clock"></i> <time v-text="timeDateEST"></time> </span>
                </div>
                </div>
                <!-- Card stats -->
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard bidside" >
            <div class="row">
                <div class="col-xl-12">
                    <div class="row">
                        <div class="col-xl-3">
                           <div class="row">
                                <div class="col-xl-12 col-md-12 mb-3">
                                    <offerWidget v-bind:offerStatus="offerStatus"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-md-12 mb-3">
                                    <CusipWidget />
                                </div>
                            </div>
                        </div>                        
                        <div class="col-xl-3">
                            <div class="row">
                                <div class="col-xl-12 col-md-6 mb-3">
                                    <SettingsWidget />
                                </div>
                            </div>
                            <div class="row h-50">
                                <div class="col-xl-12 col-md-6 mb-3">
                                    <AccountWidget/>
                                </div>
                                <div class="col-xl-12 col-md-6">
                                    <IntraDayTradesWidget v-bind:offerStatus="offerStatus"  />
                                </div>
                            </div>      
                        </div>
                        <div class="col-xl-6">
                            <div class="row">
                                <div class="col-xl-6 col-md-6 mb-3">
                                    <!-- <MsrbWidget v-bind:offerStatus="offerStatus" /> -->
                                    
                                    <TraderWidget />
                                </div>
                                <div class="col-xl-6 col-md-6 mb-3">
                                    <CustomerWidget/>                                    
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-md-12 mb-3">
                                    <OfferingStatusWidget />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import moment_timezone from 'moment-timezone'
import offerWidget from './ImsOffersWidgets'
import AccountWidget from './ImsAccountsWidgets'
//import MsrbWidget from './ImsMsrbWidget'
import IntraDayTradesWidget from './ImsIntraDayTradesWidget'
import CusipWidget from './ImsCusipWidget'
import TraderWidget from './ImsTradersWidget'
import CustomerWidget from './ImsCustomersWidget'
import OfferingStatusWidget from './ImsOfferingStatusWidet'
import SettingsWidget from './ImsSettingsWidget'
import authService from "@/authService";
import config from "@/config";
export default {
  name: "ims-dashboard",
   components: {
       offerWidget,
       AccountWidget,
       IntraDayTradesWidget,
       CusipWidget,
       TraderWidget,
       CustomerWidget,
       OfferingStatusWidget,
       SettingsWidget
  },
  data() {
    return {
      timeDate : "",
      timeDateEST : "",
      offerStatus : {},
      isAdmin: false,
      isTrader : false,
      isEditor : false
      
    };
  },
  methods: {
    getOfferStatus(){
      this.loading = true;
      let url = "/offer/stats";
      if((!this.isAdmin || !this.isEditor) && this.isTrader){
        url = "/offer/stats?cognitoSub="+authService.getUser().cognitoSub
      }
      //console.log(this.isAdmin)
      //let cognitoSub = (!this.isAdmin || !this.isEditor) && this.isTrader ? authService.getUser().cognitoSub : " ";
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
        config.baseUrlBidSide + url,
          auth
      )
      .then(result => {
        this.offerStatus = result.data;
        this.loading = false;
      })

    }
    
  },
  mounted() {
    setInterval(() => {
      this.timeDate =  moment().format('LT') + " | " + moment().format('dddd') + ", " + moment().format("DD MMM YYYY"); 
      this.timeDateEST =  moment_timezone().tz('America/New_York').format('LT') + " | " + moment_timezone().format('dddd') + ", " + moment_timezone().format("DD MMM YYYY");  
    }, 1000);
    
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          this.getOfferStatus();

        }
        //console.log("isa",this.isAdmin);
      });
   
  }
};
</script>